'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormSelect = function (_React$Component) {
  (0, _inherits3.default)(FormSelect, _React$Component);

  function FormSelect() {
    (0, _classCallCheck3.default)(this, FormSelect);
    return (0, _possibleConstructorReturn3.default)(this, (FormSelect.__proto__ || (0, _getPrototypeOf2.default)(FormSelect)).apply(this, arguments));
  }

  (0, _createClass3.default)(FormSelect, [{
    key: 'render',
    value: function render() {
      var title = this.props.title;

      var styles = require('./FormSelect.scss');

      return _react2.default.createElement(
        'div',
        { className: this.props.className, style: { marginTop: '25px' } },
        _react2.default.createElement(
          'label',
          { className: styles.FormSelect },
          _react2.default.createElement(
            'span',
            { className: styles.FormSelect__label },
            title
          ),
          _react2.default.createElement(
            _components.Select,
            (0, _extends3.default)({}, this.props, { className: styles.Select }),
            this.props.children
          )
        )
      );
    }
  }]);
  return FormSelect;
}(_react2.default.Component);

exports.default = FormSelect;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FormSelect/FormSelect.jsx
// module id = 2616
// module chunks = 0